// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2PlhJ","addWidgetButton":"Header_addWidgetButton__1QJem","dashboardTabs":"Header_dashboardTabs__1Pcet","active":"Header_active__SjAGV"};